import {
  Container,
  Stack,
  Box,
  Text,
  Heading,
  Wrap,
  Badge,
  Button,
  Divider,
  List,
  ListItem,
  ListIcon,
  Alert,
  AlertIcon,
  AlertDescription,
} from "@chakra-ui/react";
import { ArrowBackIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import backEndLearnArray from "./backEndLearnArray";
import t from "../translations";

const MotionBox = motion(Box);

export default function BackEndTopicPage({ color }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const topics = backEndLearnArray();
  const topic = topics.find((tp) => tp.slug === slug);

  useEffect(() => {
    if (topic) {
      document.title = `${topic.company} ${t.backEndTopic.pageTitleSuffix}`;
    }
  }, [topic]);

  if (topics.length > 0 && !topic) {
    navigate("/learning", { state: { tabIndex: 1 } });
    return null;
  }

  if (!topic) return null;

  return (
    <Container maxW="3xl" pt={{ base: 20, md: 28 }} pb={{ base: 16, md: 36 }} px={{ base: 4, md: 8 }}>
      <Stack spacing={8}>
        <Button
          leftIcon={<ArrowBackIcon />}
          variant="ghost"
          colorScheme={color}
          alignSelf="flex-start"
          onClick={() => navigate("/learning", { state: { tabIndex: 1 } })}
          size="sm"
        >
          {t.backEndTopic.backButton}
        </Button>

        <MotionBox
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <Stack spacing={8}>
            <Stack spacing={2}>
              <Badge
                colorScheme={color}
                borderRadius="full"
                px={3}
                py={1}
                fontSize="sm"
                alignSelf="flex-start"
              >
                {topic.duration}
              </Badge>
              <Heading size={{ base: "lg", md: "xl" }}>{topic.company}</Heading>
              <Text color="gray.500" fontSize="lg">
                {topic.position}
              </Text>
            </Stack>

            <Divider />

            <Alert status="info" borderRadius="lg">
              <AlertIcon />
              <AlertDescription fontSize="sm">
                {t.backEndTopic.comingSoonNotice}
              </AlertDescription>
            </Alert>

            <Stack spacing={3}>
              <Text fontWeight={700} fontSize="lg">
                {t.backEndTopic.whatYoullLearnHeading}
              </Text>
              <List spacing={3}>
                {topic.listItems.map((item, i) => (
                  <ListItem key={i} color="gray.500" fontStyle="italic">
                    <ListIcon
                      as={ChevronRightIcon}
                      color={`${color}.400`}
                      boxSize={5}
                    />
                    {item}
                  </ListItem>
                ))}
              </List>
            </Stack>

            <Divider />

            <Stack spacing={3}>
              <Text fontWeight={700} fontSize="lg">
                {t.backEndTopic.technologiesHeading}
              </Text>
              <Wrap spacing={2}>
                {topic.badges.map((badge) => (
                  <Badge
                    key={badge.name}
                    colorScheme={badge.colorScheme}
                    px={3}
                    py={1}
                    fontSize="sm"
                    borderRadius="md"
                  >
                    {badge.name}
                  </Badge>
                ))}
              </Wrap>
            </Stack>
          </Stack>
        </MotionBox>
      </Stack>
    </Container>
  );
}
